import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'underscore';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Corpus, RepresentationSet } from '../../../models/corpus';
import { Endpoint, HelpIndex, MessageType, UpdateStatusType } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';

@Component({
    standalone: false,
    selector: 'res-reindex-dataset',
    templateUrl: './reindex-data-set-modal.component.html',
    styleUrls: ['./reindex-data-set-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ReindexDataSetModalComponent extends BaseModalComponent implements OnInit {
    RepresentationSet = RepresentationSet;
    dataSet: Corpus;
    representationTypes: Array<RepresentationSet>;
    originalRepresentationType: string;
    isBusy = false;
    isBusyMessage: string;
    updateContentStatus: boolean;
    modalAutomationId = 'reindex-dataset';
    modalClass = 'reindex-data-set-modal';
    modalHelpIndex = HelpIndex.imports_reindex_data_set_dlg;

    constructor(
        private modalService: BsModalService,
        public deleteEntityRef: BsModalRef,
        private restService: RestService,
        private commonService: CommonService) {
        super(modalService, deleteEntityRef);
    }

    reindex(): void {
        this.isBusy = true;
        this.isBusyMessage = 'Reindexing ...';

        let representationForApi = [this.dataSet.representationType];
        if (this.originalRepresentationType === this.dataSet.representationType) {
            representationForApi = [];
        }

        const data = {
            corpusName: this.dataSet.name, description: this.dataSet.description, sharedState: this.dataSet.sharedState,
            viewHandle: this.dataSet.corpusViewHandle, representationTypes: representationForApi, updateContent: false
        };

        this.restService.post(Endpoint.corpusManager_updateCorpusData, data)
            .then(response => {
                this.isBusy = false;
                this.commonService.sendMessage(MessageType.entityChanged, UpdateStatusType.CORPUS);
            }, error => {
                this.isBusy = false;
                this.commonService.openErrorModal(error.extendedStatus);
            });
        this.commonService.sendMessage(MessageType.entityChanged, UpdateStatusType.CORPUS);
        this.closeModal();
    }

    hideReindexDataSetModal(): void {
        this.closeModal();
    }

    ngOnInit(): void {
        this.dataSet = _.clone(this.modalData);
        this.loadData();
    }

    loadData(): void {
        this.isBusy = true;
        this.isBusyMessage = 'Loading ...';
        this.originalRepresentationType = this.dataSet.representationType;
        this.getEntriesInRepresentationType();
        this.isBusy = false;
    }

    getEntriesInRepresentationType(): void {
        this.representationTypes = [];
        switch (this.dataSet.representationType) {
            case RepresentationSet.NO_INDEX: {
                this.representationTypes.push(RepresentationSet.METADATA_INDEX);
                this.representationTypes.push(RepresentationSet.SYSTEM_METADATA_INDEX);
                this.representationTypes.push(RepresentationSet.CONTENT_INDEX);
                this.representationTypes.push(RepresentationSet.VECTOR_SET);
                break;
            }
            case RepresentationSet.METADATA_INDEX: {
                this.representationTypes.push(RepresentationSet.METADATA_INDEX);
                break;
            }
            case RepresentationSet.SYSTEM_METADATA_INDEX: {
                this.representationTypes.push(RepresentationSet.SYSTEM_METADATA_INDEX);
                break;
            }
            case RepresentationSet.CONTENT_INDEX: {
                this.dataSet.representationType = RepresentationSet.VECTOR_SET;
                this.representationTypes.push(RepresentationSet.VECTOR_SET);
                break;
            }
            case RepresentationSet.VECTOR_SET: {
                this.representationTypes.push(RepresentationSet.VECTOR_SET);
                break;
            }
        }
    }

    setRepresentationType(type: RepresentationSet): void {
        this.dataSet.representationType = type;
    }

    disableOption(type: RepresentationSet): boolean {
        return (this.representationTypes.length < 1) || !this.representationTypes.includes(type);
    }

    okEnabled(): boolean {
        return this.dataSet.representationType !== RepresentationSet.NO_INDEX;
    }
}
